import {
    API_ENDPOINTS
} from '../constants';
import {
    getAuthToken
} from './account';

export interface IAvatar {
    accountName: string;
    created: number;
    fileName: string;
    url: string;
    userName: string;
}

export const uploadAvatar = async (file: File) => {
    const body = new FormData()
    body.append('file', file)

    const request = await fetch(API_ENDPOINTS.avatars(), {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
        },
        body
    })
    return request.json();
};

export const getAvatar = async (): Promise<IAvatar | null> => {
    const request = await fetch(API_ENDPOINTS.avatars(), {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
        },
    })
    return request.json();
};


// WEBPACK FOOTER //
// ./src/services/documents.ts